export const SUCCESS = "success";
export const ERROR = "error";

export const DEVELOPMENT = process.env.NODE_ENV === "development";

export const SEGUROS = ["caser", "generali", "zurich"];
export const ESTADOSPETICIONES = [
  "pendiente cotización",
  "cotizado",
  "enviado",
];
export const SECRET_KEY = "6834170e-8005-990a-b3913506";
